(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-login/assets/javascripts/utils/utils.js') >= 0) return;  svs.modules.push('/modules/iam-login/assets/javascripts/utils/utils.js');
"use strict";


const updateCustomerProgressStatus = async value => {
  const updateFunction = value => new Promise(resolve => {
    svs.core.deviceSession.set('progressStatus', 'iam', value, err => {
      if (err) {
        svs.iam_login.logger.error('Error updating progressStatus in device session:', err);
      }
      resolve();
    });
  });
  return await updateFunction(value);
};
const updateIsNewCustomer = async value => {
  const updateFunction = value => new Promise(resolve => {
    svs.core.deviceSession.set('isNewCustomer', 'iam', value, err => {
      if (err) {
        svs.iam_login.logger.error('Error updating isNewCustomer in device session:', err);
      }
      resolve();
    });
  });
  return await updateFunction(value);
};
const setIamLoginType = async value => {
  const updateFunction = value => new Promise(resolve => {
    svs.core.deviceSession.set('loginType', 'iam', value, err => {
      if (err) {
        svs.iam_login.logger.error('Error updating loginType in device session:', err);
      }
      resolve();
    });
  });
  return await updateFunction(value);
};

const postDeviceSessionToAuthorize = async (loginType, isNewCustomer, progressStatus) => {
  try {
    var _svs;
    let target = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.iam_login) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.abortUrl;
    if (window.location.host.indexOf('local.') > -1) {
      target = window.location.origin;
    }
    const authorizationPath = svs.core.urlMapping.get('authorization') || '/authorization';
    if (!target) {
      svs.iam_login.logger.error('Target domain not available for posting device session data');
      return null;
    }
    if (!authorizationPath) {
      svs.iam_login.logger.error('Authorization URL mapping not found');
      return null;
    }

    const payload = {
      loginType,
      isNewCustomer,
      progressStatus
    };
    svs.iam_login.logger.info('Posting IAM data to authorize module:', payload);

    const url = "".concat(target).concat(authorizationPath, "/data");

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      svs.iam_login.logger.error("Failed to post IAM data to authorize module: ".concat(response.status, " ").concat(response.statusText));
      return null;
    }
    const data = await response.json();
    svs.iam_login.logger.info('Successfully posted IAM data to authorize module:', data);
    return data;
  } catch (err) {
    svs.iam_login.logger.error('Error posting IAM data to authorize module', err);
    return null;
  }
};
const getIAMData = () => new Promise((resolve, reject) => {
  svs.core.deviceSession.get('parameters', 'iam', (result, error) => {
    if (error) {
      reject(error);
    } else {
      resolve(result || {});
    }
  });
});

const postAnalyticsEvent = async function () {
  let {
    category,
    action,
    opt_label,
    opt_value
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    var _svs2;
    let target = (_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.iam_login) === null || _svs2 === void 0 || (_svs2 = _svs2.data) === null || _svs2 === void 0 ? void 0 : _svs2.abortUrl;
    if (window.location.host.indexOf('local.') > -1) {
      target = window.location.origin;
    }
    const authorizationPath = svs.core.urlMapping.get('authorization') || '/authorization';
    if (!target) {
      svs.iam_login.logger.error('Target domain not available for posting analytics event');
      return null;
    }
    if (!category || !action) {
      svs.iam_login.logger.error('Missing required analytics fields: category or action');
      return null;
    }
    const payload = {
      category,
      action
    };
    if (opt_label !== undefined) {
      payload.opt_label = opt_label;
    }
    if (opt_value !== undefined) {
      payload.opt_value = opt_value;
    }
    svs.iam_login.logger.info('Posting analytics event to authorize module:', payload);
    const url = "".concat(target).concat(authorizationPath, "/analytics");
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      credentials: 'include',
      body: JSON.stringify(payload)
    });
    if (!response.ok) {
      svs.iam_login.logger.error("Failed to post analytics event: ".concat(response.status, " ").concat(response.statusText));
      return null;
    }
    const data = await response.json();
    svs.iam_login.logger.info('Successfully posted analytics event:', data);
    return data;
  } catch (err) {
    svs.iam_login.logger.error('Error posting analytics event', err);
    return null;
  }
};

const getReturnUrlForEidApp = () => {
  var _svs3, _navigator;
  const isNativeApp = ((_svs3 = svs) === null || _svs3 === void 0 || (_svs3 = _svs3.iam_login) === null || _svs3 === void 0 || (_svs3 = _svs3.data) === null || _svs3 === void 0 ? void 0 : _svs3.isApp) || false;
  const userAgentFamily = ((_navigator = navigator) === null || _navigator === void 0 || (_navigator = _navigator.userAgent) === null || _navigator === void 0 ? void 0 : _navigator.toLowerCase()) || '';
  let returnUrl;
  if (svs.core.detect.browser.crios()) {
    if (window.location.protocol.indexOf('s') > -1) {
      returnUrl = 'googlechromes://';
    } else {
      returnUrl = 'googlechrome://';
    }
  } else if (svs.core.detect.os.iOS()) {
    const isNativePokerLogin = Boolean(svs.utils.cookie.read('is-native-poker-login'));
    if (isNativePokerLogin) {
      returnUrl = encodeURIComponent('svenskaspel-poker://');
    } else if (isNativeApp) {
      returnUrl = encodeURIComponent(window.location.href.replace(/https?/i, 'spelbutikenlb.bankid'));
    } else if (userAgentFamily.indexOf('firefox') > -1 || userAgentFamily.indexOf('fxios') > -1) {
      const url = svs.utils.url.currentUrlEncodedParams();
      returnUrl = encodeURIComponent("firefox://open-url?url=".concat(url));
    } else if (userAgentFamily.indexOf('ios') > -1 || userAgentFamily.indexOf('safari') > -1) {
      const url = svs.utils.url.currentUrlEncodedParams();
      returnUrl = encodeURIComponent(url);
    } else {
      returnUrl = 'null';
    }
  } else {
    returnUrl = 'null';
  }
  return returnUrl;
};
svs.iam_login.utils = {
  getReturnUrlForEidApp,
  getIAMData,
  updateCustomerProgressStatus,
  updateIsNewCustomer,
  setIamLoginType,
  postDeviceSessionToAuthorize,
  postAnalyticsEvent
};

 })(window);